import type { GridColDef } from "@mui/x-data-grid-premium";
import { useMemo } from "react";
import DataGrid from "@entrilia/shared/components/grid/DataGrid";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import type { OrganizationDeactivatedMember } from "../../../../../api/types/userManagementTypes";
import { getDefaultGridSx } from "../definitions";
import ManagedMemberDetails from "../invite-members/ManagedMemberDetails";
import MembersContext from "../MembersContext";

const getDeactivatedMembersGridColumns = (): GridColDef<OrganizationDeactivatedMember>[] => [
  {
    field: "name",
    headerName: "Name",
    sortable: false,
    flex: 1.5,
    renderCell: ({ row }) => <ManagedMemberDetails userName={row.name} email={row.email} />,
  },
  {
    field: "disabledAt",
    headerName: "Deactivated at",
    sortable: false,
    flex: 1,
    valueFormatter: (value) => (value ? convertISODateTime(value) : ""),
  },
];

const getRowId = (row: OrganizationDeactivatedMember) => row.userId;

const DeactivatedMembersGrid = () => {
  const { filteredDeactivatedMembers, isLoading } = useDefinedContext(MembersContext);

  const columns = useMemo(() => getDeactivatedMembersGridColumns(), []);

  return (
    <DataGrid<OrganizationDeactivatedMember>
      getRowId={getRowId}
      sx={(theme) => getDefaultGridSx(theme)}
      columns={columns}
      rows={filteredDeactivatedMembers}
      loading={isLoading}
      multilineRows
      noRowsText="No deactivated members"
    />
  );
};

export default DeactivatedMembersGrid;
